<template>
  <el-select ref="user" v-model="selected" filterable collapse-tags v-loading="loading" :multiple="false"
    :disabled="disabled ? true : false" :placeholder="$t('selecione-uma-opcao')" @change="update()">
    <el-option v-for="row of tableData" :key="row.id" :label="row.name" :value="row.id"></el-option>
  </el-select>
</template>

<script>
import { ShippingService } from "@/services/shipping/shipping.services";
export default {
  name: "UserList",
  data: function () {
    return {
      tableData: [],
      selected: "",
      loading: false,
    };
  },
  props: {
    customer: String,
    type: String,
    current: Array,
    disabled: Boolean,
  },
  watch: {
    customer: function (v) {
      const vm = this;
      vm.fetchRecords();
    },
    current: function (v) {
      const vm = this;
      vm.selected = vm.$props.current;
    },
  },
  methods: {
    fetch() {
      const vm = this;
      vm.loading = true;
      ShippingService.list(999999, 1, '')
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          this.$message({
              type: "error",
              message: error,
          });
        })
        .finally(() => vm.loading = false);
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      const selectedObject = vm.tableData.find(item => item.id === vm.selected);
      vm.$emit("selected", selectedObject);
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>